import React from "react";
import SpecialistAssignmentBoard from "./SpecialistAssignmentBoard";
import FlowEngineGlobalGate from "../specialist-flow-engine/FlowEngineGlobalGate";

const SpecialistValidatorSelectionScreen = () => {
  return (
    <FlowEngineGlobalGate>
      <SpecialistAssignmentBoard
        roleKey="validator"
        titleKey="specialist.selection.validator.title"
        defaultTitle="Bandeja del Verificador"
      />
    </FlowEngineGlobalGate>
  );
};

export default SpecialistValidatorSelectionScreen;



